<template>
    <div class="product">
       <div class="contents">
            <div class="mesg">
                <div class="cont1">
                    <div class="logo">
                        <img src="../../assets/logo1.png" alt="logo">
                        <p>Caby</p>
                    </div>
                    <div class="date">
                        <div>
                            <h2>360</h2>
                            <span>Days</span>
                        </div>
                        <div>
                            <h2>24</h2>
                            <span>hours</span>
                        </div>
                        <div>
                            <h2>60</h2>
                            <span>minutes</span>
                        </div>
                        <div>
                            <h2>60</h2>
                            <span>seconds</span>
                        </div>
                    </div>
                </div>
                <div class="cont2">
                    <div class="text">
                        <h2>Anticipate a</h2>
                        <h2>
                            Better ride for you and your
                            loved ones.
                        </h2>
                        <p>
                            we take you to anyone, anywhere in the comfortable  ride.
                        </p>
                    </div>
                </div>
            </div>
            <div class="image">
                <!-- <img src="../../" alt="backgroung"> -->
                <div class="img-box">
                    <div class="img img1">
                        <img src="../../assets/iphone1.png" alt="image">
                    </div>
                    <div class="img img2">
                        <img src="../../assets/iphone2.png" alt="image">
                    </div>
                </div>
            </div>
       </div>
       <div class="apply">
            <ApplyToDrive />
       </div>
    </div>
</template>
<script>
import ApplyToDrive from '../ApplyToDrive.vue';

    export default {
    name: "productcomp",
    components: { ApplyToDrive }
}
</script>
<style scoped>
    .product{
        position: relative;
        width: 100%;
        margin: 0;
        padding: 0;
        font-family: 'Inter', sans-serif;
        margin-bottom: 4.99rem;
    }
    .product .contents{
        /* margin: 9px; */
        position: relative;
    }
    .product .mesg{
        margin: 0;
        padding: 0;
        padding-top: 100px;
        margin-bottom: 3rem;
    }
    .mesg .logo{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 10px;
    }
    .mesg .logo img{
        width: 50px;
    }
    .mesg .logo p{
        color: #f60;
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 2rem;
    }
    .mesg .date{
        position: relative;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        justify-content: center;
        align-items: center;
        padding: 3rem;
    }
    .mesg .date > div{
        position: relative;
        background-color: #011A51;
        color: #fff;
        width: 70px;
        padding: .5rem;
        text-align: center;
        border-radius: 12px;
    }
    .mesg .date > div h2{
        letter-spacing: 1.2px;
        font-weight: 900;
        font-size: 20px;
    }
    .mesg .date > div span{
        color: #a5deff;
        font-size: 11px;
        letter-spacing: .5px;
        width: 300px;
    }
    .mesg .cont1{
        margin-bottom: 3rem;
    }
    .mesg .text{
            padding:1rem;
            text-align: center;
        }
    .mesg .text h2:nth-child(1){
        color: #f60;
        font-weight: 300;
        font-size: 22px;
    }
    
    .mesg .text h2:nth-child(2){
        color: #011a51;
        font-weight: 600;
        font-size: 28px;
        margin-bottom: 1rem;
    }
    .mesg .text p{
        color: #011A51;
        font-weight: 400;
        text-align: center;
    }
    .product .apply{
        width: 100%;
        position: relative;
        padding: 1rem;
    }
    /* .product .image{
        display: none;
    } */
    @media screen and (max-width:768px) {
        .contents .image{
            position: relative;
            width: 100%;
            height: 635px;
            padding-top: 140px;
            background-color: #011A51;
            overflow: hidden;
        }
        .image .img-box{
            position: relative;
            width: 300px;
            height: 550px;
            overflow: hidden;
            align-self: center;
            left: 10%;
        }
        .image .img-box .img{
            width: 280px;
            height: 500px;
            position: absolute;
        }
        .image .img-box .img1{
            top: 0;
            left: 0;
        }
        .image .img-box .img2{
            bottom: 0;
            right: 0;
        }
        .image .img-box .img2 img{
            position: absolute;
            top: 0;
            right: 0;
            width: 250px;
            height: 100%;
        }
        .image .img-box .img1 img{
            position: absolute;
            top: 0;
            left: 0;
            width: 250px;
            height: 100%;
        }
    }
    @media screen and (min-width:768px) {
        .contents{
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 1rem;
        }
        .mesg {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .mesg .text{
            padding: 0 0 1rem 1rem;
            text-align: left;
        }
        .mesg .logo img{
            width: initial;
        }
        .mesg .text h2:nth-child(1){
            font-weight: 300;
            font-size: 40px;
        }
        .mesg .text h2:nth-child(2){
            font-size: 40px;
            margin-bottom: 1rem;
        }
        .mesg .text p{
            font-size: 17px;
            text-align: left;
        }
        .contents .image{
            position: relative;
            width: 100%;
            height: 635px;
            /* padding-left: 2rem; */
            padding-top: 140px;
            background-color: #011A51;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .image .img-box{
            position: relative;
            width: 400px;
            height: 550px;
            overflow: hidden;
        }
        .image .img-box .img{
            width: 280px;
            height: 500px;
            position: absolute;
        }
        .image .img-box .img1{
            top: 0;
            left: 0;
        }
        .image .img-box .img2{
            bottom: 0;
            right: 0;
        }
        .image .img-box .img img{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            right: 0;
        }
        .mesg .text{
            padding: 0 0 2rem 2rem;
        }
        .mesg .date{
            padding: 0;
        }
        .mesg .date > div{
            min-width: 65px;
        }
    }
    @media screen and (min-width:1010px) {
        .mesg .text{
            padding: 0 0 2rem 4rem;
        }
        .contents{
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 1.9rem;
        }
        .mesg .logo img{
            width: initial;
        }
        .mesg .text h2:nth-child(1){
            font-weight: 300;
            font-size: 60px;
            margin-bottom: 12px;
        }
        .mesg .text h2:nth-child(2){
            font-size: 60px;
            /* line-height: 72px; */
            margin-bottom: 1rem;
        }
        .mesg .text p{
            font-size: 20px;
            text-align: left;
        }
        .contents .image{
            position: relative;
            width: 100%;
            height: 735px;
            /* padding-left: 2rem; */
            padding-top: 140px;
            background-color: #011A51;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .image .img-box{
            position: relative;
            width: 370px;
            height: 500px;
            overflow: hidden;
        }
        .image .img-box .img{
            width: 260px;
            height: 450px;
            position: absolute;
        }
        .image .img-box .img1{
            top: 0;
            left: 0;
        }
        .image .img-box .img2{
            bottom: 0;
            right: 0;
        }
        .image .img-box .img img{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            right: 0;
        }
        .mesg .date > div{
            min-width: 80px;
            padding: 1rem;
        }

    }
    @media screen and (min-width:1280px) {
        .mesg .text{
            padding: 0 0 2rem 5rem;
        }
        .mesg .text h2:nth-child(1){
            font-size: 72px;
        }
        .mesg .text h2:nth-child(2){
            font-size: 72px;
            margin-bottom: 1rem;
            line-height: 70px;
        }
    }
</style>